import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import Home from './container/Home';
import RoomMobile from './container/RoomMobile';
import Room from './container/Room';
import {InputViolationToast} from './components/Toast'
import { Loader } from './components/Loader';

import './css/App.css';
import Landing from './container/Landing';
import { ToastContainer, toast, Slide } from 'react-toastify';
import UserContext from './context/userContext'

import 'react-toastify/dist/ReactToastify.min.css';
import './css/style.css';


class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      teleport : null,
      p5:null,
      errOpen:false,
      errCode:"",
      view: window.innerWidth < 900 ? "mobile" : "desktop",
      deferredPrompt:null,
      setDf: (prompt) => {
        this.setState({deferredPrompt:prompt})
      },
      webShare:null,
      setWs: (file) => {
        this.setState({webShare: file})
      }
    }
  }

  componentDidMount() {

    console.log("In App");
    var Teleport = window.Teleport;
    var p5 = window.p5;
    var teleport = new Teleport({server:"https://teleport-app.herokuapp.com/",
    onConnect:() => {
      console.log("Checking Route");
      this.setState({teleport, p5})
    },
    error:(errCode) => {
      // this.setState({errOpen:true,errCode})
      toast.error(errCode)
    }
    })    
    navigator.serviceWorker.addEventListener('message',(event) => {
      console.log("Filesssssss");
      console.log(event.data)
      if(event.data.action === 'load') {
        this.state.setWs(event.data.files)
      } 
    })  
   
    window.addEventListener('beforeinstallprompt', (e) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      this.state.setDf(e);
      console.log("APPpwa")
    });
    if(window.Notification.permission === "default") {
      Notification.requestPermission(pr =>{
        console.log("Notification status:",pr);
      })
    }
  }
  
  render(){
    console.log("IN RENDER");
    if(this.state.teleport){
      return (
        <div id="home">
          <ToastContainer 
                  position="top-center"
                  autoClose={3000}
                  hideProgressBar
                  newestOnTop={false}
                  limit={3}
                  transition={Slide}
          />
          <UserContext.Provider value={{
            webShare:this.state.webShare,
            setWs:this.state.setWs,
            teleport:this.state.teleport,
            p5:this.state.p5,
            deferredPrompt:this.state.deferredPrompt,
            setDf:this.state.setDf,
          }}>
            <Router>
              <Route exact path="/" render={(props) => {
                return(<Home {...props} view={this.state.view}  />)
              }} />
              <Route path="/portal/:id" render={(props) => {
                if( window.innerWidth < 900 ) 
                  return(<RoomMobile {...props} p5={window.p5}  />)
                return(<Room {...props} p5={window.p5} />)
              }} />
            </Router>
          </UserContext.Provider>
          {/* <InputViolationToast open={this.state.errOpen} errorText={this.state.errCode} closeSnack={() => {this.setState({ errOpen: false})}} /> */}
        </div>
      ) 
    } else {
      return(
        <Loader />
      )
    }
  }
}

export default App;
